

















import Vue from 'vue'
import { SearchFacets } from '@/search/types'
import {
  FACET_QUERY_PREFIX,
  GENDER_FACET_KEY_NAME,
  COLOR_FACET_KEY_NAME
} from '@/search/const'
import GenderFilter from '@/search/components/prioritizedFilters/GenderFilter.vue'
import ColorFilter from '@/search/components/prioritizedFilters/ColorFilter.vue'

export default Vue.extend({
  components: {
    GenderFilter,
    ColorFilter
  },
  props: {
    searchFacets: {
      type: Array as () => SearchFacets[],
      required: true
    },
    facetValues: {
      type: Array as () => string [],
      required: true
    }
  },
  data(): {
    facetValueNames: string[]
  } {
    return {
      facetValueNames: []
    }
  },
  computed: {
    routeQuery(): { [key: string]: string } {
      return this.$route.query as { [key: string]: string }
    },
    genderFacet(): SearchFacets {
      return this.searchFacets.find(
        (item: SearchFacets) => item.facetKeyName === GENDER_FACET_KEY_NAME
      )!
    },
    colorFacet(): SearchFacets {
      return this.searchFacets.find(
        (item: SearchFacets) => item.facetKeyName === COLOR_FACET_KEY_NAME
      )!
    },
    genderFacetValue(): string {
      let result = ''
      if (this.routeQuery) {
        const genderFacet = Object.keys(this.routeQuery).find(key =>
          key === `${FACET_QUERY_PREFIX}${GENDER_FACET_KEY_NAME}`
        )
        if (genderFacet) {
          result = this.routeQuery[genderFacet].split(',')[0] || ''
        }
      }
      return result
    },
    colorFacetValue(): string {
      let result = ''
      if (this.routeQuery) {
        const colorFacet = Object.keys(this.routeQuery).find(key =>
          key === `${FACET_QUERY_PREFIX}${COLOR_FACET_KEY_NAME}`
        )
        if (colorFacet) {
          result = this.routeQuery[colorFacet].split(',')[0] || ''
        }
      }
      return result
    }
  },
  watch: {
    facetValues: {
      immediate: true,
      handler(value: string[]) {
        this.facetValueNames = value
      }
    }
  },
  methods: {
    searchFacetValues() {
      this.$emit('onSearchFacet', this.facetValueNames)
    },
    onFacetValuesChange(value: { oldValue: string; newValue: string }) {
      this.facetValueNames = this.facetValueNames.filter(item =>
        !value.oldValue.includes(item)
      )
      this.facetValueNames.push(value.newValue)
      this.searchFacetValues()
    }
  }
})
